const makeFormStyle=()=>({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent:'center',
    alignItems:'center'
})

export default makeFormStyle;